import React from 'react';
import { Container } from './styles';
import 'react-slideshow-image/dist/styles.css';

import foto1 from '../../assets/1.jpeg'
import foto2 from '../../assets/2.jpeg'
import foto3 from '../../assets/3.jpeg'
import foto4 from '../../assets/4.jpeg'
import foto5 from '../../assets/5.jpeg'
import foto6 from '../../assets/6.jpeg'
import foto7 from '../../assets/7.jpeg'
import foto8 from '../../assets/8.jpeg'
import foto9 from '../../assets/9.jpeg'
import foto10 from '../../assets/10.jpeg'
import foto11 from '../../assets/11.jpeg'
import foto12 from '../../assets/12.jpeg'
import foto13 from '../../assets/13.jpeg'
import foto14 from '../../assets/14.jpeg'
import foto15 from '../../assets/15.jpeg'
import foto16 from '../../assets/16.jpeg'
import foto17 from '../../assets/17.jpeg'
import foto18 from '../../assets/18.jpeg'
import foto19 from '../../assets/19.jpeg'
import foto20 from '../../assets/20.jpeg'
import foto21 from '../../assets/21.jpeg'
import foto22 from '../../assets/22.jpeg'
import foto23 from '../../assets/23.jpeg'
import foto24 from '../../assets/24.jpeg'
import foto25 from '../../assets/25.jpeg'
import foto26 from '../../assets/26.jpeg'
import foto27 from '../../assets/27.jpeg'
import foto28 from '../../assets/28.jpeg'
import foto29 from '../../assets/29.jpeg'
import foto30 from '../../assets/30.jpeg'

function Apresentacao() {
  return (
    <Container>
      <div>
        <br/>
        <h1>O EVENTO</h1>
        <p>A 2º edição da AGOPREV e a 4ºedição da ExpoPrev, serão o encontro de Gestores, Conselheiros e Servidores Públicos
          abordando temas atuais e fatos relevantes na área de RPPS.  o espaço ideal para adquirir conhecimentos sobre os 
          diversos temas que cercam os RPPS e interagir com Gestores de vários RPPS e os Especialistas mais renomados do Brasil.
        </p>
        <br/>
        <p>Em caso de dúvidas, basta entrar em contato pelo (62) 99609-0413 ou enviar para contato@jornadaeduc.com.br. 
        Ao realizar a inscrição, você está automaticamente concordando com as nossas políticas de privacidade e estorno.
        </p>
        <br/>
        <section>
          <div id="slide">
            <img src={foto1} alt='Foto'/>
            <img src={foto2} alt='Foto'/>
            <img src={foto3} alt='Foto'/>
          </div>
          <div id="slide">
            <img src={foto4} alt='Foto'/>
            <img src={foto5} alt='Foto'/>
            <img src={foto7} alt='Foto'/>
          </div>
          <div id="slide">
            <img src={foto8} alt='Foto'/>
            <img src={foto9} alt='Foto'/>
            <img src={foto10} alt='Foto'/>
          </div>
          <div id="slide">
            <img src={foto11} alt='Foto'/>
            <img src={foto12} alt='Foto'/>
            <img src={foto15} alt='Foto'/>
          </div>
          <div id="slide">
            <img src={foto14} alt='Foto'/>
            <img src={foto13} alt='Foto'/>
            <img src={foto16} alt='Foto'/>
          </div>
          <div id="slide">
            <img src={foto17} alt='Foto'/>
            <img src={foto18} alt='Foto'/>
            <img src={foto19} alt='Foto'/>
          </div>
          <div id="slide">
            <img src={foto20} alt='Foto'/>
            <img src={foto21} alt='Foto'/>
            <img src={foto22} alt='Foto'/>
          </div>
          <div id="slide">
            <img src={foto23} alt='Foto'/>
            <img src={foto24} alt='Foto'/>
            <img src={foto25} alt='Foto'/>
          </div>
          <div id="slide">
            <img src={foto26} alt='Foto'/>
            <img src={foto27} alt='Foto'/>
            <img src={foto28} alt='Foto'/>
          </div>
          <div id="slide">
            <img src={foto29} alt='Foto'/>
            <img src={foto30} alt='Foto'/>
            <img src={foto6} alt='Foto'/>
          </div>

        </section>
      </div>
    </Container>
  );
}

export default Apresentacao;